import styled from 'styled-components'
import {
  device, railItemWidth, size, railItemMarginRight,
  railItemLineHeight, railGridItemWidth, railItemBorderRadius
} from '../../constants/breakpoints'
/* --------------------------------------------- */
import PlayIcon from '.././icons/PlayIcon'
/* --------------------------------------------- */
import utils from '../../utils/utils'
/* --------------------------------------------- */
// Styled components for RailItems component.
export const BottomLabel = styled.div`
  height: ${({ maxItemBottomLabelLines }) => maxItemBottomLabelLines * 20}px;
`
/* --------------------------------------------- */
export const Item = styled.div`
  ${({ componentStyles, layoutType, contentType, isThisCREATE }) => {
    return componentStyles.map((singleStyle) => {
      let { filter = {}, itemSize, itemOrientation, showItemTopLabel, maxItemTopLabelLines = 0 } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      let settings = railItemWidth
      if (!showItemTopLabel) { maxItemTopLabelLines = 0 }
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        let orientation = 'landscape'
        if (itemOrientation < 1) orientation = 'portrait'
        if (itemSize === 'fill_width') orientation = 'fill_width'
        if (layoutType === 'grid') settings = railGridItemWidth
        const width = settings[orientation][itemSize][resolution]
        const widthInPX = (width / 100) * size[resolution]
        let ratio = 25
        if (itemSize === 'fill_width') ratio = widthInPX * (10 / 100)
        const scaleRatio = (widthInPX + ratio) / widthInPX
        let height = 100 * (1 / itemOrientation)
        if (layoutType === 'grid') height = width * (1 / itemOrientation)
        const margin = railItemMarginRight[orientation][itemSize][resolution]
        let marginRatio = (1 / itemOrientation) * margin
        if (resolution.indexOf('mobile') !== -1 && orientation === 'fill_width') marginRatio = 0
        let titileHeight = railItemLineHeight[resolution] * maxItemTopLabelLines
        if (showItemTopLabel) titileHeight = (railItemLineHeight[resolution] * maxItemTopLabelLines) + 8

        let spaceBetweenItemsMargin = '0'
        if (orientation === 'fill_width') {
          if (contentType === 'channels' && isThisCREATE) spaceBetweenItemsMargin = `0 ${margin}px 150px 0`
          else spaceBetweenItemsMargin = `0 ${margin/2}px`

        } else {
          if (contentType === 'channels' && isThisCREATE) spaceBetweenItemsMargin = `0 ${margin}px 150px 0`
          else spaceBetweenItemsMargin = `0 ${margin}px 0 0`

        }

        return `
            @media ${device[resolution]} { 
              margin: ${spaceBetweenItemsMargin};
              width: calc(${layoutType === 'grid' ? width : 100}% - ${(resolution.indexOf('mobile') !== -1 && orientation === 'fill_width') ? 0 : margin}px);
              transition: transform 0.5s;
              padding-top: ${contentType === 'channels' && isThisCREATE ? `calc(${height}% - ${marginRatio}px + ${titileHeight}px + 60px)` : `calc(${height}% - ${marginRatio}px + ${titileHeight}px)`};

              &:hover {
                transform: scale(${scaleRatio}) translateZ(0);
              }

              &:hover .layout-item__title {
                -webkit-font-smoothing: subpixel-antialiased;
                filter: blur(0)
              }
            }
          `
      })
    })
  }}
  .next-program{
    z-index: 5;
    margin-top: 60px;
    border: none;
  }
  .remaining_time_p {
    color: ${({ theme: { body } }) => body && body?.text?.tertiary};

  }
`

/* --------------------------------------------- */
export const FavDelBtn = styled.div`
  background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton.normal.background};

  & p {
    color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton.normal.text};
  }

  &:hover{
    background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton.focussed.background};
  }
`
/* --------------------------------------------- */
export const ImgHolder = styled.div`      
  ${({ componentStyles, isTitleInsideImg, images = [], theme, contentType, isThisCREATE, isShowRailItemInfo }) => {
    return componentStyles.map((singleStyle) => {
      let { filter = {}, itemSize, itemEdgeRadius, itemOrientation, showItemTopLabel, showItemTitle, maxItemTopLabelLines = 0, maxItemTitleLines = 0 } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      if (!showItemTopLabel) { maxItemTopLabelLines = 0 }
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        /* --------------------------------------------- */
        const curve = railItemBorderRadius[itemSize] * itemEdgeRadius
        const minus = railItemLineHeight[resolution] * maxItemTitleLines
        let titileHeight = railItemLineHeight[resolution] * maxItemTopLabelLines
        if (showItemTopLabel) titileHeight = railItemLineHeight[resolution] * maxItemTopLabelLines + 8
        let orientation = 'landscape'
        /* --------------------------------------------- */
        if (itemOrientation < 1) orientation = 'portrait'
        if (itemSize === 'fill_width') orientation = 'fill_width'
        const width = railItemWidth[orientation][itemSize][resolution]
        const widthInPX = (width / 100) * size[resolution]
        const height = widthInPX * (1 / itemOrientation)
        let img = utils.getCloserMatchImage(widthInPX, height, images)
        if (!img & images.length > 0) img = images[0]
        /* --------------------------------------------- */
        img = img ? img.url : ''
        if (!img) {
          // There is no image available as per the previous logic. returning the first image that's matching either portrait or landscape 
          // based on the expected height & width.
          const expectedMode = width > height ? 'portrait' : 'landscape';
          const allImagesMatchingExpectedMode = images?.filter(i => i.type === expectedMode ) || []
          img = allImagesMatchingExpectedMode[0]?.url
        }
        img = window.escape(img)
        img = img.replace(/https%3A/g, 'https:')
        img = img.replace(/http%3A/g, 'http:')

        let borderRadius = `${curve}px;`
        if (isShowRailItemInfo) borderRadius = `${curve}px ${curve}px 0 0`
        else if (showItemTopLabel) borderRadius = `0 0 ${curve}px ${curve}px`

        return `
          border-image-width: 0;
          background-color: ${theme.body && theme.body.background.tertiary};
          @media ${device[resolution]} { 
            height: ${!isTitleInsideImg && (showItemTopLabel || showItemTitle) ? `calc(100% - ${minus}px - ${titileHeight}px - 10px)` : '100%'} ;  
            width: 100%;
            border-radius: ${borderRadius};
            top: ${contentType === 'channels' && isThisCREATE ? `${showItemTopLabel ? `${titileHeight}px!important` : '46px'}` : `${showItemTopLabel ? `${titileHeight}px!important` : ''}`}
            
            & .img-holder__hover-container {
              border-radius: ${showItemTopLabel ? `0 0 ${curve}px ${curve}px` : `${curve}px`};
            }

            & .layout-item__premium-tag {
              border-radius: ${showItemTopLabel ? `0 0 ${curve}px ${curve}px` : `${curve}px`};
            }

            & ~.layout-item__title---inside-img {
              border-radius: ${showItemTopLabel ? `0 0 ${curve}px ${curve}px` : `${curve}px`};
            }
          }
          
          // &:hover{
          //   background-color: transparent;
          // }
          
            @media ${device[resolution]} { 
              border-radius: ${borderRadius};
              background-image: url("${img}");
              background-repeat: ${contentType === 'channels' && isThisCREATE ? 'no-repeat' : 'no-repeat'};
              background-size: ${contentType === 'channels' && isThisCREATE ? '50%' : '100% 100%'};
            }
        `
      })
    })
  }}
`
/* --------------------------------------------- */
export const Title = styled.div`
  color: ${({ theme: { body } }) => body && body.text.primary};
  // position: ${({ isTitleInsideImg }) => isTitleInsideImg ? 'absolute' : 'relative'};
  // bottom: 0;
  position: ${({ contentType, isTitleInsideImg, isThisCREATE }) => contentType === 'channels' && isThisCREATE ? 'absolute' : `${isTitleInsideImg ? 'absolute' : 'relative'}`};
  bottom: ${({ contentType, isThisCREATE }) => contentType === 'channels' && isThisCREATE ? '' : '0'};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  margin-top:  ${({ isTitleInsideImg }) => isTitleInsideImg ? '0' : '10px'};
  & > a, & > span {
    color: ${({ theme: { body } }) => body && body.text.primary};
    white-space: normal;
  }
  
  ${({ componentStyles, isTitleInsideImg }) => {
    return componentStyles.map((singleStyle) => {
      const { filter = {}, maxItemTitleLines = 0 } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        return `
        @media ${device[resolution]} {
          height: ${!isTitleInsideImg ? `${((railItemLineHeight[resolution]) * maxItemTitleLines)}px` : `${20 * maxItemTitleLines}px`};
          line-height: ${!isTitleInsideImg ? `${railItemLineHeight[resolution]}px` : '20px'};
          -webkit-line-clamp: ${maxItemTitleLines};

        }
      `
      })
    })
  }}
`

export const ProgressBar = styled.div`
  ${({ duration, progress, theme }) => {
    const totalLength = duration
    const currentProgress = progress
    let widthInpercentage = Math.ceil((currentProgress / totalLength) * 100)
    if (widthInpercentage > 100) widthInpercentage = 100
    if (widthInpercentage < 0) widthInpercentage = 0
    return `
    background: ${theme?.body?.background?.secondary};
          &:after {
            width: ${widthInpercentage}%;
            background: ${theme?.body?.accent?.primary};
          }
        }
      `
  }}
  `
/* --------------------------------------------- */
export const TopLabel = styled.div`
  color: ${({ theme: { body } }) => body && body.text.primary};
  background: ${({ theme: { body }, isLive }) => {
    if (!body) return
    if (isLive) return body.background.secondary
    else return body.background.tertiary
  }};
  ${({ componentStyles, topLabelTextLength }) => {
    return componentStyles.map((singleStyle) => {
      const { filter = {}, itemSize, maxItemTopLabelLines, itemEdgeRadius } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      return Object.keys(railItemLineHeight).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        const curve = railItemBorderRadius[itemSize] * itemEdgeRadius
        return `
          @media ${device[resolution]} { 
            height: ${railItemLineHeight[resolution] * maxItemTopLabelLines + 8}px;
            min-height: 25px;
            line-height: ${railItemLineHeight[resolution]}px;
            border-radius: ${curve}px ${curve}px 0 0;
            font-size: 14px;
            overflow: hidden;
          }

          & p {
            @media ${device[resolution]} {
              line-height: ${railItemLineHeight[resolution]}px;
              font-size: 14px;
              white-space: normal;
              -webkit-line-clamp: ${topLabelTextLength ? `${maxItemTopLabelLines - 1}` : `${maxItemTopLabelLines}`};
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              display: block;
              overflow: hidden;
            }
          }
        `
      })
    })
  }}
`
/* --------------------------------------------- */
export const PlayIconWithTheme = styled(PlayIcon).attrs(
  ({ theme: { body } }) => ({
    color: body && body.accent.secondary,
    height: 27,
    width: 27
  })
)`
`
/* --------------------------------------------- */
export const HoverContainer = styled.div`
  opacity: 0;
  transition: 0.3s;
  cursor: pointer;
  &:hover{
    background: ${({ theme: { body } }) => body && body.accent.primary};
    opacity: 0;
  }
`


